import { Box, css, Grid } from '@mui/material'
import Lottie from 'react-lottie'

import { useMQ } from '../hooks/useMQ'
import * as DePinAnimation from './animations/depin.json'
import * as RWAAnimation from './animations/rwa.json'
import * as TradeFinanceAnimation from './animations/tradefinance.json'
import * as Web3CreditCardsAnimation from './animations/web3cc.json'
import * as CrossBorderFinanceAnimation from './animations/xborder.json'
import { BlurBox } from './BlurBox'
import { HumaScrollAnimation } from './HumaScrollAnimation'
import { Title } from './Title'

export function GlobalMoneyMovement() {
  const { isSmSize, isXsSize } = useMQ()

  const pools: {
    title: string
    description: string
    link?: string
    disabled?: boolean
    media: any
  }[] = [
    {
      title: 'Cross-Border Payment Financing',
      description:
        'Settle cross-border payments instantly without pre-funding, eliminating delays, capital lockups, and unnecessary costs.',
      media: CrossBorderFinanceAnimation,
    },
    {
      title: 'Stablecoin Backed Cards',
      description:
        'Transform card payments with stablecoins—real-time settlement, on-chain control, and lower fees by design.',
      media: Web3CreditCardsAnimation,
    },
    {
      title: 'T+0 Settlement',
      description:
        'Institutional-ready, same-day settlement that eliminates capital inefficiencies and accelerates financial operations across borders.',
      media: RWAAnimation,
    },
    {
      title: 'Trade Finance',
      description:
        'Modernize how suppliers get paid—faster settlement, less friction, more growth.',
      media: TradeFinanceAnimation,
    },
    {
      title: 'DePIN Financing',
      description:
        'Unlock capital for DePIN networks with innovative financing solutions built for a new era of infrastructure.',
      media: DePinAnimation,
    },
  ]

  const styles = {
    wrapper: css`
      margin-top: ${isXsSize ? '72px' : '160px'};
    `,
    content: css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 0px;
      row-gap: 24px;
    `,
    industryImageWrapper: css`
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    ctaText: css`
      margin-left: 8px;
    `,
    pool: css`
      padding: 30px 0px;
      padding-right: ${isSmSize ? '0px' : '100px'};
    `,
    poolTitle: css`
      font-family: 'Red-Hat-Display';
      font-size: ${isXsSize ? '16px' : '24px'};
      text-align: ${isXsSize ? 'center' : 'left'};
      font-weight: 700;
      color: #fbfbfc;
      line-height: 50px;
      letter-spacing: 0.46px;
    `,
    poolBody: css`
      margin: auto;
    `,
    poolDescription: css`
      color: #848484;
      font-size: ${isXsSize ? '14px' : '18px'};
      letter-spacing: 0.17px;
      font-weight: 400;
    `,
    poolButton: css`
      width: ${isXsSize ? '100%' : '200px'};
      height: ${isXsSize ? '42px' : '48px'};
      border: 1px solid transparent;
      background: linear-gradient(#000 0 0) padding-box,
        linear-gradient(to right, #f1bcff, #c733ff) border-box;
      color: #e192ff;
    `,
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet',
    },
  }

  return (
    <Box css={styles.wrapper}>
      <HumaScrollAnimation>
        <Title title='Accelerating Global Money Movement' />
      </HumaScrollAnimation>
      <Box css={styles.content}>
        {pools.map((item) => (
          <HumaScrollAnimation key={item.title}>
            <BlurBox fadedBorder centered>
              <Grid container css={styles.pool}>
                <Grid item xs={12} sm={4} css={styles.industryImageWrapper}>
                  <Lottie
                    options={{ ...defaultOptions, animationData: item.media }}
                    height={120}
                    isClickToPauseDisabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={8} css={styles.poolBody}>
                  <Box css={styles.poolTitle}>{item.title}</Box>
                  <Box css={styles.poolDescription}>{item.description}</Box>
                </Grid>
              </Grid>
            </BlurBox>
          </HumaScrollAnimation>
        ))}
      </Box>
    </Box>
  )
}
